// extracted by mini-css-extract-plugin
export default {"userProfileContainer":"UserProfile_userProfileContainer__RqZMS","iconItem":"UserProfile_iconItem__+C8UQ","optionIcon":"UserProfile_optionIcon__agKYW"};